import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-495bbc65"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href", "target", "download"]
const _hoisted_2 = ["type", "form"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.btnType === 'link')
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: _ctx.href,
        class: _normalizeClass([_ctx.classes, _ctx.className]),
        target: _ctx.target,
        download: _ctx.download
      }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], 10, _hoisted_1))
    : (_ctx.btnType === 'button')
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: _normalizeClass([_ctx.classes, _ctx.className]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args))),
          type: _ctx.type,
          form: _ctx.form
        }, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 10, _hoisted_2))
      : (_ctx.btnType === 'router-link')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: _ctx.route,
            class: _normalizeClass([_ctx.classes, _ctx.className])
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ]),
            _: 3
          }, 8, ["to", "class"]))
        : _createCommentVNode("", true)
}